export enum TABS {
  EXPORT = 'export',
  IMPORT = 'import',
  YML_SETTINGS = 'yml-settings',
  FIELD_METADATA_EDITOR = 'field-metadata-editor',
  THEME = 'theme',
  GLOBAL_ID = 'global-id',
  DATE_TIME_FORMAT = 'date-and-time',
  ADMIN_HELPERS = 'admin-helpers',
  EMAIL_SETTINGS = 'email-settings',
  NOTIFICATIONS_SETTINGS = 'notifications-settings',
  WORKDAY_CONFIG = 'workday-config'
}
